import { LOCATION_CHANGE, RouterAction } from "connected-react-router"
import { Reducer } from "redux"
import { OrgMemberType, AuthUserType } from "../../../Actions/Types"
import { APIOrgMember, getOrgId } from "../../../Models/API/APIOrgMember"
import {
    getInitialData,
    markAllPagesOfAllEntriesAsStale,
    RemoteData,
    setPage
} from "../../../Models/Client/RemoteData"
import { SortExpression } from "../../../Models/Client/SortExpression"
import { AuthAction } from "../../Auth"
import { UserAction } from "../../Auth/UserReducer"

export interface OrgMemberState {
    myOrgs: RemoteData<APIOrgMember, {}, string>
    members: {
        [orgUsername: string]:
            | RemoteData<APIOrgMember, SortExpression<APIOrgMember>, string>
            | undefined
    }
}

interface OrgMemberSetMyOrgsAction {
    type: OrgMemberType.setMyOrgs
    payload: APIOrgMember[]
}

interface OrgMemberSetOrgMembersAction {
    type: OrgMemberType.setOrgMembers
    meta: {
        total: number
        page: number
        orgUsername: string
        sort: SortExpression<APIOrgMember>
    }
    payload: APIOrgMember[]
}

export type OrgMemberAction =
    | OrgMemberSetMyOrgsAction
    | OrgMemberSetOrgMembersAction

const initialState: OrgMemberState = {
    myOrgs: getInitialData(),
    members: {}
}

export const OrgMemberReducer: Reducer<
    OrgMemberState,
    UserAction | OrgMemberAction | AuthAction | RouterAction
> = (state = initialState, action): OrgMemberState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                members: markAllPagesOfAllEntriesAsStale(state.members)
            }
        case OrgMemberType.setMyOrgs:
            return {
                ...state,
                myOrgs: setPage(
                    state.myOrgs,
                    {},
                    action.payload,
                    getOrgId,
                    0,
                    action.payload.length
                )
            }
        case OrgMemberType.setOrgMembers:
            return {
                ...state,
                members: {
                    ...state.members,
                    [action.meta.orgUsername]: setPage(
                        state.members[action.meta.orgUsername] ??
                            getInitialData(),
                        action.meta.sort,
                        action.payload,
                        getOrgId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
